import { Component, OnInit } from '@angular/core';
import {NgForm} from '@angular/forms';
import {Observable} from 'rxjs';
import * as firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/database";


@Component({
  selector: 'app-addnews',
  templateUrl: './addnews.component.html',
  styleUrls: ['./addnews.component.css']
})
export class AddnewsComponent implements OnInit {


  pictureurl:any;
  description:any;
  name:any;
    constructor() { }

    ngOnInit() {
    }
  save(faculty:NgForm){
    let value = faculty.value;
    let descript = document.getElementById('display').innerHTML;
    let pictureurlsi = document.getElementById('pictureurl').innerHTML;
    console.log(pictureurlsi);
      let pictureurls = JSON.parse(pictureurlsi);
      let pictureurl = pictureurls.image;

    let desc = {desc:descript, pictureurl: pictureurl};
    let p ={...desc, ...faculty.value}
    console.log(p);
    let timi = Date.now();
    let d = new Date(timi);
    let years = ["January", "February", "March", "April", "May",
  "June", "July", "August", "September", "October", "November", "December"]
  let gettingyear = d.getFullYear();
  let gettingmonths = () =>{
    let e = d.getMonth();
    console.log(years[e]);
    return years[e];
  }
  let gettingday = d.getDate();
    let id = p.name;
    let db= firebase.database();
    db.ref('news/'+timi).set({pictureurl: p.pictureurl,
    description: p.desc, name:timi, title:id,  date: gettingday + " "+gettingmonths() +" "+ gettingyear}, function(error){
      if(error){
        alert(error)
      }else{alert('data saved successfully')}
    })
  }
  }
